// 安卓兼容版本
export const ANDROID_SESSION_ID = '2.22.0'
export const SYSTEM_SHARE_APP_VERSION = '6.2.0'
